module.exports = __webpack_public_path__ + "static/media/university.4a0ff53e.svg";